var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.title,
      rightMethod: _vm.onSubmitted,
      rightButtonText: _vm.$t("add"),
      large: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-tabs",
              {
                attrs: { color: "transparent", "show-arrows": "" },
                model: {
                  value: _vm.tab,
                  callback: function($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab"
                }
              },
              [
                _c("v-tabs-slider", { attrs: { color: "primary" } }),
                _vm._v(" "),
                _vm._l(_vm.tabs, function(tabItem) {
                  return _c(
                    "v-tab",
                    { key: tabItem, attrs: { href: "#" + tabItem } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(tabItem.toLowerCase())) +
                          "\n        "
                      )
                    ]
                  )
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "v-tabs-items",
              {
                model: {
                  value: _vm.tab,
                  callback: function($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab"
                }
              },
              [
                _c(
                  "v-tab-item",
                  { attrs: { value: "Single" } },
                  [
                    _vm.tab === "Single"
                      ? _c(
                          "v-container",
                          { attrs: { fluid: "", "grid-list-lg": "" } },
                          [
                            _c(
                              "v-layout",
                              {
                                attrs: {
                                  "align-bottom": "",
                                  "justify-start": ""
                                }
                              },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { md3: "" } },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.barcodeLabel,
                                        rules: [_vm.fieldIsRequired("UPC")]
                                      },
                                      model: {
                                        value: _vm.barcode,
                                        callback: function($$v) {
                                          _vm.barcode =
                                            typeof $$v === "string"
                                              ? $$v.trim()
                                              : $$v
                                        },
                                        expression: "barcode"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md3: "" } },
                                  [
                                    _c("v-select", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("size"),
                                        items: _vm.upcSizes,
                                        "item-text": "name",
                                        "item-value": "sortKey",
                                        rules: [_vm.fieldIsRequired("Size")]
                                      },
                                      model: {
                                        value: _vm.size,
                                        callback: function($$v) {
                                          _vm.size = $$v
                                        },
                                        expression: "size"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.mode === "sku"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            items: _vm.organizations,
                                            "item-text": "organizationId",
                                            "item-value": "key",
                                            label: _vm.$t("organizationId"),
                                            clearable: "",
                                            rules: [
                                              _vm.fieldIsRequired(
                                                "organization"
                                              )
                                            ]
                                          },
                                          model: {
                                            value: _vm.organizationKey,
                                            callback: function($$v) {
                                              _vm.organizationKey = $$v
                                            },
                                            expression: "organizationKey"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.size === "custom"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("inboundFee"),
                                            prefix: "$"
                                          },
                                          model: {
                                            value: _vm.inboundFee,
                                            callback: function($$v) {
                                              _vm.inboundFee = _vm._n($$v)
                                            },
                                            expression: "inboundFee"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.size === "custom"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("outBoundFee"),
                                            prefix: "$"
                                          },
                                          model: {
                                            value: _vm.outboundFee,
                                            callback: function($$v) {
                                              _vm.outboundFee = _vm._n($$v)
                                            },
                                            expression: "outboundFee"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.size === "custom"
                                  ? _c(
                                      "v-flex",
                                      { attrs: { md3: "" } },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: _vm.$t("storageFee"),
                                            prefix: "$"
                                          },
                                          model: {
                                            value: _vm.storageFee,
                                            callback: function($$v) {
                                              _vm.storageFee = _vm._n($$v)
                                            },
                                            expression: "storageFee"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  { attrs: { md3: "" } },
                                  [
                                    _c("v-text-field", {
                                      attrs: { label: _vm.$t("snTemplate") },
                                      model: {
                                        value: _vm.snTemplate,
                                        callback: function($$v) {
                                          _vm.snTemplate = $$v
                                        },
                                        expression: "snTemplate"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-flex",
                                  [
                                    _c("v-text-field", {
                                      staticClass: "required_field",
                                      attrs: {
                                        label: _vm.$t("description"),
                                        rules: [
                                          _vm.fieldIsRequired("Description")
                                        ],
                                        autofocus: ""
                                      },
                                      model: {
                                        value: _vm.description,
                                        callback: function($$v) {
                                          _vm.description = $$v
                                        },
                                        expression: "description"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasQueryFunction
                      ? _c(
                          "v-container",
                          { attrs: { fluid: "" } },
                          [
                            _c(
                              "v-layout",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      dark: "",
                                      color: "primary",
                                      loading: _vm.isLoading
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.queryUpc(_vm.barcode)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("queryUPC")))]
                                ),
                                _vm._v(" "),
                                _vm.queryLimit !== "-1"
                                  ? _c("v-flex", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("queryLimitQueriesLeftToday", {
                                            queryLimit: _vm.queryLimit
                                          })
                                        )
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.error
                              ? _c(
                                  "v-layout",
                                  [_c("v-flex", [_vm._v(_vm._s(_vm.error))])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-layout",
                              [
                                _vm.queryImage
                                  ? _c(
                                      "div",
                                      [
                                        _c("v-img", {
                                          attrs: {
                                            src: _vm.queryImage,
                                            "lazy-src": _vm.queryImage,
                                            width: "180",
                                            contain: ""
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "v-flex",
                                  [
                                    _vm.queryName
                                      ? _c(
                                          "v-layout",
                                          { attrs: { "align-center": "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { md9: "" } },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("name")) + ":"
                                                  )
                                                ]),
                                                _vm._v(
                                                  " " + _vm._s(_vm.queryName)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { "ml-3": "" } },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      dark: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.copyUpcDescription(
                                                          _vm.queryName
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("copy"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.queryDetail
                                      ? _c(
                                          "v-layout",
                                          { attrs: { "align-center": "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              { attrs: { md9: "" } },
                                              [
                                                _c("strong", [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("detail")) +
                                                      ":"
                                                  )
                                                ]),
                                                _vm._v(
                                                  " " + _vm._s(_vm.queryDetail)
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-flex",
                                              { attrs: { "ml-3": "" } },
                                              [
                                                _c(
                                                  "v-btn",
                                                  {
                                                    attrs: {
                                                      dark: "",
                                                      color: "primary"
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.copyUpcDescription(
                                                          _vm.queryDetail
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("copy"))
                                                    )
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-tab-item",
                  { attrs: { value: "Multiple" } },
                  [
                    _c("v-textarea", {
                      staticClass: "mt-2",
                      attrs: { label: _vm.$t("inputUPCInfoHere"), outline: "" },
                      model: {
                        value: _vm.text,
                        callback: function($$v) {
                          _vm.text = $$v
                        },
                        expression: "text"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a32631c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a32631c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InboundAddUpcPopup.vue
// module id = null
// module chunks = 